import React from "react";

function IconHide() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M.3 9.8A10.36 10.36 0 0110 3.01c4.54 0 8.14 2.83 9.7 6.77.07.18.07.38 0 .55a10.36 10.36 0 01-9.7 6.78c-4.54 0-8.14-2.84-9.7-6.78a.75.75 0 010-.55zm1.51.27A8.84 8.84 0 0010 15.62a8.84 8.84 0 008.19-5.55A8.84 8.84 0 0010 4.52a8.84 8.84 0 00-8.19 5.55z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M10 7.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM6.25 10a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M1.47 18.53a.75.75 0 010-1.06l16-16a.75.75 0 111.06 1.06l-16 16c-.3.3-.77.3-1.06 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconHide;
